'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo, useRef } from 'react';
import { useGSAP } from '@gsap/react';
import WorkCard from './card-work';
import { gsap } from '@/lib/gsap';
import { chunkifyArray } from '@/lib/utils';
import HalfLayout from '@/components/layouts/half-layout';
import type { Work } from '@/data/works';
interface ShowcaseLayoutProps {
  works: Work[];
}
const ShowcaseLayout = t0 => {
  const $ = _c(9);
  const {
    works
  } = t0;
  const containerRef = useRef(null);
  let chunked;
  if ($[0] !== works) {
    chunked = chunkifyArray(works, 3);
    if (chunked.length > 1 && chunked[chunked.length - 1].length < 2) {
      chunked.pop();
    }
    $[0] = works;
    $[1] = chunked;
  } else {
    chunked = $[1];
  }
  const rows = chunked;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const rowElements = containerRef.current?.querySelectorAll("[data-work-row]");
      if (!rowElements) {
        return;
      }
      rowElements.forEach(_temp);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== rows) {
    t2 = {
      scope: containerRef,
      dependencies: [rows]
    };
    $[3] = rows;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useGSAP(t1, t2);
  let t3;
  if ($[5] !== rows) {
    t3 = rows.map(_temp2);
    $[5] = rows;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div ref={containerRef}>{t3}</div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default ShowcaseLayout;
function _temp(rowEl) {
  const cards = rowEl.querySelectorAll("[data-work-card]");
  if (!cards.length) {
    return;
  }
  gsap.fromTo(cards, {
    y: 10,
    opacity: 0
  }, {
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.18,
      from: "end"
    },
    duration: 0.8,
    ease: "power4.out",
    scrollTrigger: {
      trigger: rowEl,
      start: "top 80%"
    }
  });
}
function _temp2(row, rowIndex) {
  return <div key={rowIndex} data-work-row={true} className="mt-8 grid gap-5 md:mt-12 md:gap-8"><HalfLayout className="flex flex-col gap-5 md:flex-row"><HalfLayout.LeftChild className="grid grid-cols-1 gap-5 md:grid-cols-2"><div data-work-card={true}><WorkCard work={row[0]} /></div>{row[1] && <div data-work-card={true}><WorkCard work={row[1]} /></div>}</HalfLayout.LeftChild><HalfLayout.RightChild>{row[2] && <div data-work-card={true}><WorkCard work={row[2]} /></div>}</HalfLayout.RightChild></HalfLayout></div>;
}